import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from 'primereact/button';
import { format } from 'date-fns';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'; // To use <ConfirmDialog> tag
import axios from "axios";

export const IspitiDataTable = (props) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [expandedRows, setExpandedRows] = useState([]);

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span>{data.datum}</span>
      </React.Fragment>
    );
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  const rejectFunc = () => {
    console.log("Odustao");
  }

  function subtractDays(date, days) {
    const dateCopy = new Date(date);
  
    dateCopy.setDate(dateCopy.getDate() - days);
  
    return dateCopy;
  }

  const confirmPrijava = (ispit) => {
      confirmDialog({
          message: 'Jeste li sigurni da želite prijaviti ispit?',
          header: 'Potvrda prijave',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Da",
          rejectLabel: "Ne",
          accept: () => handlePrijaviIspit(ispit),
          reject: () => rejectFunc()
      });
  }

  const confirmOdjava = (ispit) => {
      confirmDialog({
          message: 'Jeste li sigurni da želite odjaviti ispit?',
          header: 'Potvrda odjave',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Da",
          rejectLabel: "Ne",
          accept: () => handleOdjaviIspit(ispit),
          reject: () => rejectFunc()
      });
  }

  const handlePrijaviIspit = async (ispit) => {
    const prijavaIspitaData = {   datumPrijave: format(new Date(), 'dd.MM.yyyy.') ,
                                  odjava: 'false',
                                  idPrekvBiljeskeNastave: ispit.id_prekv_biljeske_nastave,
                                  idPrekvPredmetPolaznika: ispit.id_predmet_polaznika
                                };
    const headers = { 
                      'Authorization': sessionStorage.getItem("token"),
                      'Content-Type': 'application/json'
                    };
                
    const response = await axios.post( props.restPrijava + sessionStorage.getItem("ustanova"), JSON.stringify(prijavaIspitaData), { headers });

    if (response.status === 200) {
      console.log("Status: " + response.status);
      window.location.reload(false);
    } else {
      console.log("Status: " + response.status);
    }
  };

  const handleOdjaviIspit = async (ispit) => {
    const odjavaIspitaData = {  datumOdjave: format(new Date(), 'dd.MM.yyyy.'),
                                odjava: 'true',
                                idPrekvPolazniciPrijavnicaIspita: ispit.id_pppi
                              };
    const headers = { 
                      'Authorization': sessionStorage.getItem("token"),
                      'Content-Type': 'application/json'
                    };

    const response = await axios.post( props.restOdjava + sessionStorage.getItem("ustanova"), JSON.stringify(odjavaIspitaData), { headers });

    if (response.status === 200) {
      console.log("Status: " + response.status);
      window.location.reload(false);
    } else {
      console.log("Status: " + response.status);
    }
  };

  const prijavaOdjavaColumn = (ispit) => {
    var date = subtractDays(new Date(ispit.termin), 15);
      if (  date > new Date() && ispit.datum_prijave_ispita === null && ispit.odjava !== true) {
        return <Button className={"botun-prijavi"} label="Prijavi" onClick={ () =>{ confirmPrijava(ispit); } }>
                  <ConfirmDialog/>
                </Button>;
      } else if ( ispit.termin > new Date().toJSON() && ispit.datum_prijave_ispita !== null && ispit.odjava !== true && ispit.datum_odjave_ispita === null) {
        return <Button className={"botun-odjavi"} label="Odjavi" onClick={ () =>{ confirmOdjava(ispit); } }>
                <ConfirmDialog/>
              </Button>;
      } else {
        return <></>
      }
  };

  const terminIspitaColumn = (ispit) => {
    if ( ispit.termin !== null )
      return format(new Date(ispit.termin), 'dd.MM.yyyy. HH:mm');
    else 
      return "";
  }

  const datumPrijaveColumn = (ispit) => {
    if ( ispit.datum_prijave_ispita !== null )
      return format(new Date(ispit.datum_prijave_ispita), 'dd.MM.yyyy.');
    else 
      return "";
  }
  
  const datumOdjaveColumn = (ispit) => {
    if ( ispit.datum_odjave_ispita !== null )
      return format(new Date(ispit.datum_odjave_ispita), 'dd.MM.yyyy.');
    else 
      return "";
  }

  return (
    <div className="centerText">
      <DataTable
        value={props.data}
        rowGroupMode="subheader"
        groupRowsBy="datum"
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={ headerTemplate }
        stripedRows
        responsiveLayout="scroll"
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={ onCustomPage }
        paginatorClassName="justify-content-end"
      >
        <Column
          field="datum"
          header="Datum objave"
          className="table-column-date"
        ></Column>
        <Column
          field="naziv_predmeta"
          header="Predmet"
          className="table-column-course"
        ></Column>
        <Column 
          field="biljeska" 
          header="Bilješka"
          className="table-column-course"
        ></Column>
        <Column
          field="termin"
          header="Termin ispita"
          body = { terminIspitaColumn }
          className="table-column-date"
        ></Column>
        <Column
          field="datum_prijave_ispita"
          header="Datum prijave"
          body = { datumPrijaveColumn }
          className="table-column-date"
        ></Column>
        <Column
          field="datum_odjave_ispita"
          header="Datum odjave"
          body = { datumOdjaveColumn }
          className="table-column-date"
        ></Column>
        <Column 
          header="Prijava/Odjava"
          body={ prijavaOdjavaColumn }
          className="table-column-date"
        ></Column>
      </DataTable>
    </div>
  );
};

export default IspitiDataTable;
